export const global = {
    emailAddress: "Email Address",
    password: "Password",
    oldpassword: "Old Password",
    newpassword: "New Password",
    firstName: "First Name",
    lastName: "Last Name",
    name: "Name",
    description: "Description",
    company: "Company",
    login: "Login",
    logout: "Logout",
    loading: "Loading",
    passwordEnter: "Your desired password",
    confirmPassword: "Confirm password",
    continue: "Continue",
    back: "Back",
    schedule: "Schedule",
    statusHeader: "Status",
    tasks: "Tasks",
    label: "Label",
    type: "Type",
    due: "Due",
    clone: "Clone",
    delete: "Delete",
    edit: "Edit",
    error: "Error",
    phone: "Phone",
    dashboard: "Dashboard",
    norecords: "No records found",
    termsAndConditions: "By signing up, you agree to our <a style='color: blue' href='https://checkmate.software/terms-and-conditions/' target='_blank'>terms & conditions</a>",
    acceptTermsAndConditions: "You must accept our terms and conditions",
    FreeTrialNoSubscription: "You are currently within your free trial which ends in {date}, create a subscription now to avoid interruption.",
    FreeTrialWithSubscription: "You are currently within your free trial which ends in {date}",
    NoFreeTrialNoSubscription: "Your free trial has ended, create a subscription to avoid interruption.",
    multipletimes: "Check can be done multiple times per day",
    introduction: "Please watch our introduction video for our quick start guide",
    recurrance: {
        repeat: "Schedule",
        last: "Last",
        lastWeekday: "Last Weekday",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        yearly: "Yearly",
        days: "days",
        weeks: "weeks",
        months: "months",
        years: "years",
        repeatEvery: "Repeat every",
        day: "Day",
        month: "Month",
        onThe: "on the ",
        of: " of ",
        before: "Before",
        monthnames: {
            january: "January",
            february: "February",
            march: "March",
            april: "April",
            may: "May",
            june: "June",
            july: "July",
            august: "August",
            september: "September",
            october: "October",
            november: "November",
            december: "December"
        },
        weekdays: {
            sunday: "Su",
            monday: "Mo",
            tuesday: "Tu",
            wednesday: "We",
            thursday: "Th",
            friday: "Fr",
            saturday: "Sa"
        }
    },
    fullweekdays: {
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday"
    },
    buttons: {
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        create: "Create",
        move: "Move",
        upload: "Upload",
        download: "Download",
        add: "Add",
        edit: "Edit",
        close: "Close",
        send: "Send",
        resolve: "Resolve",
        addParameter: "Add Parameter",
        runQuery: "Run Query",
        exportToCsv: "Export to CSV",
        sendTestEmail: "Send Test Email",
        yes: "Yes"
    },
    status: {
        active: "Active",
        disabled: "Disabled",
        enabled: "Enabled",
        pending: "Pending",
        completed: "Completed",
        failed: "Failed",
        success: "Success",
        resolved: "Resolved",
        open: "Open"
    },
    labels: {
        email: "Email",
        search: "Search",
        status: "Status",
        userType: "User Type",
        defaultLocation: "Default Location",
        from: "From: ",
        to: "To: ",
        severity: "Severity",
        reportedBy: "Reported By",
        created: "Created",
        issue: "Issue",
        check: "Check",
        checks: "Checks",
        task: "Task",
        users: "Users",
        subscriptionType: "Interval",
        key: "Key",
        value: "Value",
        folderName: "Folder Name",
        size: "Size",
        uploaded: "Uploaded",
        renewalPeriod: "Renewal period",
        price: "Price",
        description: "Description",
        min: "Min",
        max: "Max",
        issues: "Issues",
        category: "Category",
        attachments: "Attachments",
        location: "Location"
    },
    placeholders: {
        search: "Search",
        selectFolder: "Select a folder",
        enterSqlQuery: "Enter your SQL query here...",
        enterEmailBody: "Enter your HTML email body here...",
        recipientEmail: "recipient@example.com",
        resolutionReason: "Resolution reason",
        checksOptional: "Checks (Optional)",
        selectCategory: "Select categories"
    },
    messages: {
        noDataFound: "No data found",
        fillRequiredFields: "Fill all the required fields",
        emptyFoldersDeleted: "Please note, empty folders are automatically deleted.",
        na: "N/A"
    }
}

export const validation = {
    nameCannotBeEmpty: "Name cannot be empty.",
    descriptionCannotBeEmpty: "Description cannot be empty.",
    priceCannotBeEmpty: "Price cannot be empty.",
    fieldCannotBeEmpty: "Field cannot be empty.",
    invalidValue: "Invalid value",
    temperatureRange: "{name} temperature cannot be lower than {min}℃ or more than {max}℃"
}